import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { NumberToCurrencyPipe } from '../../../../shared/pipes/number-to-currency.pipe';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ICard } from '../../../cards/core/interfaces/ICard';
import { ICardType } from '../../../cards/core/interfaces/ICardType';
import { ICardPaymentDialogData } from '../../core/interfaces/ICardPaymentDialogData';
import { CartService } from '../../core/services/CartService';

@Component({
  selector: 'app-card-payment-balance-info-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    NumberToCurrencyPipe,
    CommonModule
  ],
  templateUrl: './card-payment-balance-info-modal.component.html',
  styleUrl: './card-payment-balance-info-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardPaymentBalanceInfoModalComponent extends BaseModalComponent<ICardPaymentDialogData> {

  @Output() openCardAmountPicker = new EventEmitter<{ card: ICard; cardType: ICardType; loadAmountOffset: number; }>();

  private readonly _cartService = inject(CartService);

  public onLoadCard(): void {
    this.openCardAmountPicker.emit({ 
      card: this.data.card, 
      cardType: this.data.cardType,
      loadAmountOffset: this.data.minLoadAmount
    });

    this.close();
  }

  public onPartialPayment(): void {
    this.close();
  }

  public onCancel(): void {
    if (this.data?.card?.cardId) {
      this._cartService.detachCardFromCart(this.data.card.cardId)
        .subscribe({
          next: () => {
            this.close();
          },
          error: ({ error }: ApiErrorResponse) => {
            this.notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`cart/notifications/${error.message}.Message`)
            );
            this.close();
          }
        });
    } else {
      this.close();
    }
  }
}
